<template>
  <cube-page
    class="info-show"
    title="个人信息"
  >
    <div slot="content">
      <div><span style="margin-left:30px;margin-bottom:20px;margin-top:20px">账号：</span>{{ userData.userName }}
      </div>
      <cube-form
        style="width: 90%;margin-left: 15px;"
        :model="editModel"
      >
        <cube-form-group>
          <cube-form-item :field="fields[0]"></cube-form-item>
          <cube-form-item :field="fields[1]"></cube-form-item>
          <cube-form-item :field="fields[2]"></cube-form-item>
        </cube-form-group>

        <cube-form-group>
          <cube-button style="margin-bottom: 20px;margin-top: 15px" @click="handleSave">保存</cube-button>
        </cube-form-group>

        <cube-form-group>
          <cube-button style="margin-bottom: 20px;" @click="handleModifyPassword">修改密码</cube-button>
        </cube-form-group>

        <cube-form-group>
          <cube-button @click="loginOutHandle">退出登录</cube-button>
        </cube-form-group>
      </cube-form>
    </div>

  </cube-page>
</template>

<script>
/**
 * 个人信息组件
 * @author Sky
 */
import personalDetailsApi from '@/api/personalDetails'
import { isNameLange, isvalidMobile, validateEmail } from '../../utils/validate'
import { getUserNew } from '@/api/common'
import CubePage from '../../components/cube-page'
import { asyncLoginOut } from '@/api/auth'

export default {
  name: 'PersonalDetails',
  components: { CubePage },
  data () {
    return {
      validity: {},
      valid: undefined,
      areaList: [],
      fields: [
        {
          type: 'input',
          modelKey: 'realName',
          label: '姓名',
          props: {
            placeholder: '请输入姓名'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'mobileNum',
          label: '手机',
          props: {
            placeholder: '请输入手机号'
          }
        }, {
          type: 'input',
          modelKey: 'email',
          label: '邮箱',
          props: {
            placeholder: '请输入邮箱'
          }
        }],

      options: {
        scrollToInvalidField: true,
        layout: 'standard' // classic fresh
      },
      orgList: [],
      companyList: [],
      drugList: [],
      editModel: {
        realName: '',
        email: '',
        mobileNum: ''
      },

      userData: {},
      isModifyPassword: false,
      clearable: {
        visible: true,
        blurHidden: true
      }
    }
  },
  filters: {
    filterName (list) {
      if (list === undefined) {
        return
      }
      return list.map((item) => item.name).toString()
    }
  },
  created () {
    this.loadUserData()
  },
  activated () {
    this.loadUserData()
  },
  methods: {
    loadUserData () {
      this.userData = {}
      this.editModel = {
        realName: '',
        email: '',
        mobileNum: ''
      }
      this.getUserNewData()
      this.$store
        .dispatch('GetUserInfo')
        .catch(() => {
          this.$store.dispatch('FedLogOut').then(() => {
            this.$route.push({ path: '/' })
          })
        })
    },
    // 退出登录
    loginOutHandle () {
      // 百度统计事件追踪
      this.$store.dispatch('PushHmtTrackEvent', {
        category: '退出登录',
        action: '点击'
      })
      // 上报操作日志
      this.$store
        .dispatch('PushUserLog', {
          menu: '个人中心',
          page: '个人中心',
          operation: '退出登录'
        })
        .then(() => {
          // 接口退出登录
          asyncLoginOut()
            .then(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
            .catch(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
        })
        .catch(() => {
          /// 接口退出登录
          asyncLoginOut()
            .then(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
            .catch(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
        })
    },
    getUserNewData () {
      getUserNew().then((res) => {
        if (res.code === 1) {
          this.userData = res.data
          this.editModel.realName = this.userData.realName // 初始化姓名
          this.editModel.email = this.userData.email
          this.editModel.mobileNum = this.userData.mobile
        }
      })
    },
    handleModifyPassword () {
      this.$router.push({ name: 'EditPassword' })
    },
    // 修改登录真实姓名
    handleSave () {
      const vm = this
      if (!isNameLange(this.editModel.realName)) {
        if (this.editModel.realName === '') {
          vm.$createDialog({
            title: '提示',
            type: 'alert',
            content: '姓名不能为空'
          }).show()
        } else {
          vm.$createDialog({
            title: '提示',
            type: 'alert',
            content: '姓名最大长度为50字符'
          }).show()
        }
        return
      }
      if (!vm.editModel.realName) {
        vm.$createDialog({
          title: '提示',
          type: 'alert',
          content: '请输入姓名'
        }).show()
        return
      }
      this.editModel.mobileNum = this.editModel.mobileNum.replace(/\s*/g, '')
      if (this.editModel.mobileNum !== '') {
        if (!isvalidMobile(this.editModel.mobileNum)) {
          vm.$createDialog({
            title: '提示',
            type: 'alert',
            content: '请输入正确格式的手机号码'
          }).show()
          return
        }
      }
      if (this.editModel.email !== '') {
        if (!validateEmail(this.editModel.email)) {
          vm.$createDialog({
            title: '提示',
            type: 'alert',
            content: '请输入正确格式的邮箱地址'
          }).show()
          return
        }
      }
      const data = {
        uuid: this.userData.uuid,
        userRealName: vm.editModel.realName,
        mobile: this.editModel.mobileNum,
        email: this.editModel.email
      }
      personalDetailsApi.updateUser(data).then(() => {
        vm.$createDialog({
          title: '提示',
          type: 'success',
          content: '操作成功'
        }).show()
      })
    }
  }
}
</script>

<style lang="stylus">
.popover-box {
    max-height: 600px;
    overflow: auto;
}

.el-popover .el-tag {
    margin-left: 10px;
    margin-bottom: 10px;
    background-color: rgba(144, 147, 153, 0.1);
    border-color: rgba(144, 147, 153, 0.2);
    color: rgb(144, 147, 153);
}

.el-tag-content {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
